export const cssBundleHref = "/build/css-bundle-QXGK6UDD.css";